import { Carousel, Slide } from "vue-carousel";
import { mapActions, mapGetters, mapMutations } from "vuex";
import _ from "lodash";
import CategorySelect from "@/modules/categories/components/select";

export default {
    name: "brand",
    data() {
        return {
            selectedFilters: [],
        };
    },
    components: {
        CategorySelect,
        Carousel,
        Slide,
    },
    props: {
        brandsList: {
            type: Array,
            default: () => [],
        },
        slug: {
            type: String,
            default: "brend",
        },
    },
    computed: {
        ...mapGetters({
            filterCategories: "setting/filterCategories",
        }),
    },
    watch: {},
    created() {
        if (this.$route.params.filterSlug) {
            const element = this.brandsList[0].values.find(item => item.slug === this.$route.params.filterSlug);
            if (element) {
                this.selectedFilters.push({
                    slug: element.slug,
                    itemSlug: element.slug,
                });
            }
        }
        if (Object.keys(this.$route.query).length) {
            Object.keys(this.$route.query).map(key => {
                this.$route.query[key].split(",").map(filterElement => {
                    this.selectedFilters.push({
                        slug: key,
                        itemSlug: filterElement,
                    });
                });
            });
        }
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchList: `category/GET_FILTER_PRODUCTS_LIST`,
        }),
        generateFilterLink(filterOption) {
            const { params, query, name } = this.$route;
            const routeQuery = { ...query };
            const hasFilterSlug = params.filterSlug;

            if (hasFilterSlug && params.filterSlug === filterOption.slug) {
                const { filterSlug, ...otherParams } = params;
                return {
                    name,
                    params: { ...otherParams },
                    query: { ...query },
                };
            } else {
                if (this.checkSlug(routeQuery, filterOption)) {
                    return {
                        name,
                        params,
                        query: routeQuery,
                    };
                }

                if (!hasFilterSlug) {
                    return {
                        name,
                        params: {
                            ...params,
                            filterSlug: filterOption.slug,
                        },
                        query: { ...query },
                    };
                } else {
                    routeQuery[this.slug] = filterOption.slug;
                    return {
                        name,
                        params: { ...params },
                        query: routeQuery,
                    };
                }
            }
        },
        checkSlug(routeQuery, filterOption) {
            if (Object.keys(routeQuery).length && routeQuery[this.slug]) {
                let existingSlugs = routeQuery[this.slug].split(",");
                const slugIndex = existingSlugs.indexOf(filterOption.slug);
                switch (slugIndex) {
                    case -1:
                        existingSlugs.push(filterOption.slug);
                        break;
                    default:
                        existingSlugs.splice(slugIndex, 1);
                        break;
                }
                if (existingSlugs.length === 0) {
                    delete routeQuery[this.slug];
                } else {
                    routeQuery[this.slug] = existingSlugs.join(",");
                }
                return true;
            }
            return false;
        },
        filter(item) {
            const index = this.selectedFilters.findIndex(filter => filter.itemSlug === item.slug);
            if (index > -1) {
                this.selectedFilters.splice(index, 1);
            } else {
                this.selectedFilters.push({
                    slug: this.slug,
                    itemSlug: item.slug,
                });
            }
            this.$emit("updateHandler");
        },
    },
};
